// Fresh Mock data for Tecfinity LLC website - USA Market

export const services = [
  {
    id: 1,
    title: 'Web Development',
    icon: 'Globe',
    features: ['Lightning Speed', 'Bank-Grade Security', 'Future-Proof Scale'],
    link: '/web-development'
  },
  {
    id: 2,
    title: 'Mobile Apps',
    icon: 'Smartphone',
    features: ['Intuitive Design', 'iOS & Android', 'Blazing Performance'],
    link: '/mobile-app'
  },
  {
    id: 3,
    title: 'Software Development',
    icon: 'Code',
    features: ['Enterprise Ready', 'Military-Grade Security', '24/7 Support'],
    link: '/software-development'
  },
  {
    id: 4,
    title: 'E-Commerce',
    icon: 'ShoppingCart',
    features: ['One-Click Checkout', 'PCI Compliant', 'Conversion Optimized'],
    link: '/ecommerce'
  },
  {
    id: 5,
    title: 'Blockchain',
    icon: 'Link',
    features: ['Web3 Ready', 'Immutable Records', 'Decentralized Trust'],
    link: '/blockchain'
  },
  {
    id: 6,
    title: 'UI/UX Design',
    icon: 'Palette',
    features: ['User-Centric', 'Accessibility First', 'Conversion-Driven'],
    link: '/ui-ux-design'
  },
  {
    id: 7,
    title: '3D Animation',
    icon: 'Box',
    features: ['Cinematic Quality', 'Brand Storytelling', 'Award-Winning'],
    link: '/3d-animation'
  },
  {
    id: 8,
    title: 'Cloud Solutions',
    icon: 'Cloud',
    features: ['99.9% Uptime', 'Auto-Scaling', 'Global CDN'],
    link: '/cloud-solutions'
  },
  {
    id: 9,
    title: 'Marketing',
    icon: 'TrendingUp',
    features: ['Lead Generation', 'Brand Strategy', 'Data-Driven ROI'],
    link: '/marketing'
  },
  {
    id: 10,
    title: 'Copywriting',
    icon: 'FileText',
    features: ['SEO Optimized', 'Conversion Copy', 'Brand Voice'],
    link: '/copywriting'
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: 'Starter Package',
    price: 499,
    icon: 'Zap',
    description: 'Perfect for small businesses and startups ready to establish their digital presence.',
    features: [
      '3-Page Professional Website',
      'Modern Responsive Design',
      'Contact Form Integration',
      'Custom Banner Design',
      'High-Quality Stock Images (2)',
      'FREE Custom Favicon',
      'All Major Browsers Supported',
      'W3C Validated Code',
      'First Draft in 48 Hours',
      'Full Design & Launch',
      'Complete Source Code',
      'Dedicated Account Manager',
      'Full Ownership Rights',
      '100% Satisfaction Promise',
      'Money-Back Guarantee'
    ],
    valueAdded: [
      'Mobile Responsive: +$200*',
      'Content Management System: +$250*',
      '*NO HIDDEN FEES OR MONTHLY CHARGES*'
    ]
  },
  {
    id: 2,
    name: 'Growth Package',
    price: 899,
    icon: 'Rocket',
    featured: true,
    description: 'Ideal for growing businesses that need more pages and advanced features.',
    features: [
      '5-Page Professional Website',
      'Premium Custom Design',
      'Advanced Contact Forms',
      'Multiple Banner Designs (3)',
      'Premium Stock Images (5)',
      'FREE Custom Favicon',
      'FREE SEO-Friendly Sitemap',
      'Unlimited Design Revisions',
      'W3C Validated HTML/CSS',
      'Rapid 48-Hour Delivery',
      'Complete Launch Support',
      'All Source Files Included',
      'Priority Project Manager',
      'Complete Ownership Rights',
      '100% Satisfaction Guarantee',
      'Full Money-Back Promise'
    ],
    valueAdded: [
      'Mobile Responsive: +$200*',
      'CMS Integration: +$250*',
      '*ZERO MONTHLY FEES FOREVER*'
    ]
  },
  {
    id: 3,
    name: 'Enterprise Package',
    price: 1499,
    icon: 'Award',
    description: 'Complete solution for established businesses requiring advanced functionality.',
    features: [
      'Up to 10 Custom Pages',
      'Full CMS/Admin Dashboard',
      'Premium Stock Photos (5+)',
      'FREE Social Media Integration',
      'FREE Custom Favicon Design',
      'FREE Google Sitemap',
      'Unlimited Revisions',
      'Cross-Browser Perfection',
      'W3C Certified HTML/CSS',
      '48-Hour Initial Concepts',
      'Full Development & Launch',
      'Dynamic & Interactive Features',
      'Expert Design & Dev Team',
      'All Source Files Delivered',
      'Executive Project Manager',
      'Complete Ownership',
      '100% Satisfaction Promise',
      'Money-Back Guarantee'
    ],
    valueAdded: [
      'Mobile Responsive: +$200*',
      'Advanced CMS: +$250*',
      '*LIFETIME NO MONTHLY FEES*'
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a',
    text: 'Working with Invotage transformed our digital strategy. They delivered a stunning website that increased our leads by 340% in just three months. The team at Invotage is exceptional and truly understands modern business needs!'
  },
  {
    id: 2,
    name: 'Marcus Thompson',
    image: 'https://images.unsplash.com/photo-1685760259914-ee8d2c92d2e0',
    text: 'The mobile app Invotage built exceeded all expectations. Our customer engagement skyrocketed, and the app runs flawlessly on both iOS and Android. Worth every penny!'
  },
  {
    id: 3,
    name: 'David Chen',
    image: 'https://images.pexels.com/photos/10919461/pexels-photo-10919461.jpeg',
    text: 'Invotage developed custom software that automated 80% of our workflow. Their technical expertise and attention to detail made the entire process seamless and efficient.'
  },
  {
    id: 4,
    name: 'Jennifer Rodriguez',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e',
    text: 'Our e-commerce revenue doubled after Invotage optimized our checkout process and implemented their secure payment system. Game-changing results that transformed our business!'
  },
  {
    id: 5,
    name: 'Robert Williams',
    image: 'https://images.unsplash.com/photo-1425421669292-0c3da3b8f529',
    text: 'Invotage\'s blockchain solution gave us the transparency and security we needed. The smart contracts they developed revolutionized how we do business in the digital age.'
  },
  {
    id: 6,
    name: 'Emily Parker',
    image: 'https://images.unsplash.com/photo-1496180470114-6ef490f3ff22',
    text: 'The UI/UX redesign by Tecfinity increased our user retention by 250%. Their design thinking approach truly understands what customers want.'
  }
];

export const blogs = [
  {
    id: 1,
    title: 'Why Every Business Needs a Scalable Website in 2026',
    excerpt: 'Discover how scalability has become the defining factor for businesses that want to thrive in the digital landscape.',
    image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085',
    date: 'January 15, 2026',
    author: 'Tecfinity Team',
    slug: 'web-design-trends-2026',
    readTime: '8 min read'
  },
  {
    id: 2,
    title: 'Mobile-First Development: Why It Matters Now More Than Ever',
    excerpt: 'With 73% of users accessing websites via mobile, learn why mobile-first development is no longer optional but essential.',
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c',
    date: 'January 12, 2026',
    author: 'Tecfinity Team',
    slug: 'mobile-first-development',
    readTime: '7 min read'
  },
  {
    id: 3,
    title: 'AI Integration in Modern Business Software: The Future is Now',
    excerpt: 'Explore how artificial intelligence is transforming business operations and why your company should embrace AI-powered solutions.',
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995',
    date: 'January 8, 2026',
    author: 'Tecfinity Team',
    slug: 'ai-integration-business-software',
    readTime: '9 min read'
  }
];

export const stats = {
  clients: '300+',
  reviews: '120+',
  replyRate: '95%',
  projects: '150+',
  satisfaction: '95%',
  support: '24/7'
};

export const trustMetrics = {
  businesses: '120+',
  rating: '4.8/5',
  reviewCount: '60+',
  monthlyTraffic: '4.3k'
};
